import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getRuleService = (drawingRuleId) => {
  return getData(
    `maintenance/drawingDependency/get?drawingRuleId=${drawingRuleId}`
  );
};

export const deleteDrawingRule = async (payload) => {
  return await deleteData("maintenance/drawingDependency/delete", payload);
};
export const createDrawingRule = async (payload) => {
  return await putData("maintenance/drawingDependency/bulkCreate", payload);
};
export const updateDrawingRule = async (payload) => {
  return await postData("maintenance/drawingInformation/update", payload);
};

// export const getRulesService = (drawingId ) => {
//     return getData(`maintenance/drawingInformation/get?drawingId=${drawingId }`);
// }

export const getRulesService = (drawingId) => {
  return getData(`maintenance/GetDrawingRuleInfo/get?drawingId=${drawingId}`);
};

export const createNewDrawingRule = async (payload) => {
  return await putData("maintenance/drawingRule/create", payload);
};

export const deleteRule = async (payload) => {
  return await deleteData("maintenance/drawingRule/delete", payload);
};
